import * as React from "react";
import { SelectEditor } from "../../../../../../../react-core/Html/SelectEditor";
import { SourceOfWealthOption } from "../../../../../../../Wrap/Constants/Enums/Apply/SourceOfWealthOption";
import { IProcessComponentProps, ProcessComponent } from "../../../../../../Shared/Process/Process/ProcessComponent";
import { SourceOfWealthArrary, SourceOfWealthArraryMap } from "../../../NewBusinessWizard/Resource/Contents";
import { SectionHeader } from "../../../NewBusinessWizard/Components/SharedComponents";
import { PensionBase } from "../../../../../../../Wrap/Models/Models/QuoteAndApplyBase/PensionBase";
import { TextBoxEditor } from "../../../../../../../react-core/Html/TextBoxEditor";

interface ISourceOfWealthProps extends IProcessComponentProps {}

interface ISourceOfWealthState {}

export class SourceOfWealth extends ProcessComponent<ISourceOfWealthProps, ISourceOfWealthState> {
    componentDidMount() {
        super.componentDidMount();
        const { data, onChange } = this.props;
        if (!data?.ClientSinglePayment?.OriginOfFunds) {
            this.onDataChange(onChange, { OriginOfFunds: SourceOfWealthOption.Salary }, data, "ClientSinglePayment");
        }
    }

    private renderSourceOfWealth(data: PensionBase, onChange) {
        // TO CONFIRM: bind to which model property
        return (
            <SelectEditor
                cssWrapper="control-size-430"
                options={SourceOfWealthArrary}
                getText={(v) => SourceOfWealthArraryMap[v]}
                required="Please select Source of wealth"
                placeholder="Please select"
                selected={data?.SourceOfWealth?.SourceOfWealthOption}
                onChange={(v) => this.onDataChange(onChange, { SourceOfWealthOption: v }, data, "SourceOfWealth")}
            />
        );
    }

    private renderOtherSourceOfWealth(data: PensionBase, onChange) {
        return (
            <TextBoxEditor
                cssWrapper="control-size-430"
                label="Other source of wealth"
                onChange={(v) => this.onDataChange(onChange, { OtherSourceOfWealth: v }, data, "SourceOfWealth")}
                value={data?.SourceOfWealth?.OtherSourceOfWealth}
                maxLength={50}
                required="Please enter other source of wealth"
            />
        );
    }

    private renderSoW(data: PensionBase, onChange) {
        return (
            <>
                <hr />
                {SectionHeader("Source of wealth")}
                {this.renderSourceOfWealth(data, onChange)}
                {data?.SourceOfWealth?.SourceOfWealthOption == SourceOfWealthOption.Other &&
                    this.renderOtherSourceOfWealth(data, onChange)}
            </>
        );
    }
    public render(): JSX.Element {
        const { data, onChange } = this.props;
        return <>{this.renderSoW(data, onChange)}</>;
    }
}
